module.exports = __webpack_public_path__ + "4e312fe023e94337773f25a8cee7d25c.png";